/**
 * Mobile-Menu Toggle. 1:1 Verhalten aus design-preview/index.html <script>.
 *
 * Markup:
 *   <button data-mobile-toggle aria-controls="mobile-menu" aria-expanded="false">
 *   <div id="mobile-menu" class="hidden"> ... </div>
 *
 * - Toggle per Button-Klick (aria-expanded + class="hidden" toggle)
 * - Body-Scroll wird gesperrt (overflow-hidden), waehrend Menue offen
 * - Klick auf Link im Menue schliesst es automatisch
 * - ESC schliesst das Menue und fokussiert den Toggle-Button zurueck
 */
export function initMobileMenu(): void {
    const btn = document.querySelector<HTMLButtonElement>('[data-mobile-toggle]')
    const menu = document.getElementById('mobile-menu')

    if (!btn || !menu) return

    const setOpen = (open: boolean): void => {
        btn.setAttribute('aria-expanded', String(open))
        menu.classList.toggle('hidden', !open)
        document.body.classList.toggle('overflow-hidden', open)
    }

    btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true'
        setOpen(!isOpen)
    })

    menu.querySelectorAll('a').forEach((a) => {
        a.addEventListener('click', () => setOpen(false))
    })

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
            setOpen(false)
            btn.focus()
        }
    })
}
